__turbopack_context__.v({
  "consentText": "_qoqbW_consentText",
  "expandToggle": "_qoqbW_expandToggle",
});
